import React from 'react';
import { Stepper, Step, StepLabel } from '@mui/material';
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined';
import CreditCardRounded from '@mui/icons-material/CreditCardRounded';
import CheckCircleOutlined from '@mui/icons-material/CheckCircleOutlined';

interface Props {
    activeStep: number;
    steps: string[];
}

interface CustomStepLabelProps {
    label: string;
    step: number;
}

const CustomStepLabel = ({ label, step }: CustomStepLabelProps) => {
    const stepIcons: { [key: number]: React.ReactElement } = {
        0: <ShoppingCartOutlinedIcon />,
        1: <CreditCardRounded />,
        2: <CheckCircleOutlined />
    };

    return (
        <StepLabel
            sx={theme => ({
                '& .MuiSvgIcon-root': {
                    fontSize: 18,
                    [theme.breakpoints.down('sm')]: {
                        fontSize: 16
                    }
                }
            })}
            icon={stepIcons[step]}
        >
            {label}
        </StepLabel>
    );
};

export default function CheckoutStepper({ activeStep, steps }: Props) {
    return (
        <Stepper activeStep={activeStep} alternativeLabel>
            {steps.map((label: string, index: number) => {
                const stepProps: { completed?: boolean } = {};
                return (
                    <Step key={label} {...stepProps}>
                        <CustomStepLabel label={label} step={index} />
                    </Step>
                );
            })}
        </Stepper>
    );
}
